<template>
  <div class="right-bottom">
    <div class="right-top" @click="goHead"></div>
    <div class="right-down" @click="goPanoBack"></div>
  </div>
</template>

<script>
export default {
  props: {
    krpano: "",
  },
  data() {
    return {};
  },
  methods: {
      // 前进
    goHead() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex++;
      if (sceneIndex >= this.krpano.get("scene.count")) {
        sceneIndex = 0;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");
      this.krpano.call(
        "loadscene(" +
          newSceneName +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
    },
    // 后退
    goPanoBack() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex--;
      if (sceneIndex < 0) {
        sceneIndex = this.krpano.get("scene.count") - 1;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");

      this.krpano.call(
        "loadscene(" +
          newSceneName +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.right-bottom {
  width: 0.81rem;
  height: 2.5rem;
  position: absolute;
  right: 0.56rem;
  bottom: 2.5rem;
  .right-top {
    width: 100%;
    height: 1.21rem;
    background-image: url("../../assets/img/phone/top.png");
    @include background-com();
    margin-bottom: 2px;
  }
  .right-down {
    width: 100%;
    height: 1.21rem;
    background-image: url("../../assets/img/phone/down.png");
    @include background-com();
   
  }
}
</style>